import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export enum SIGN_UP_STAGE {
  INITIAL,
  DISCLOSURE,
  PHONE,
  SUBSCRIPTION,
  UNSUPPORTED_COUNTRY,
}

export enum SUBSCRIPTION_STAGE {
  SUBSCRIPTION,
  SUBSCRIPTION_SUCCESS,
  SUBSCRIPTION_NOT_NOW,
}

export enum PHONE_VALIDATION_STAGE {
  INPUT,
  CODE_SENT,
  CODE_RESENT,
}

export interface ISignUpFormState {
  signUpStage: SIGN_UP_STAGE;
  subscriptionStage: SUBSCRIPTION_STAGE;
  phoneValidationStage: PHONE_VALIDATION_STAGE;
}

export const initialState: ISignUpFormState = {
  signUpStage: SIGN_UP_STAGE.INITIAL,
  subscriptionStage: SUBSCRIPTION_STAGE.SUBSCRIPTION,
  phoneValidationStage: PHONE_VALIDATION_STAGE.INPUT,
};

const SignUpFormSlice = createSlice({
  name: "signUpForm",
  initialState: initialState,
  reducers: {
    setSignUpStage: (state, action: PayloadAction<SIGN_UP_STAGE>) => {
      state.signUpStage = action.payload;
    },
    setSubscriptionStage: (state, action: PayloadAction<SUBSCRIPTION_STAGE>) => {
      state.subscriptionStage = action.payload;
    },
    setPhoneValidationStage: (state, action: PayloadAction<PHONE_VALIDATION_STAGE>) => {
      state.phoneValidationStage = action.payload;
    },
  },
});

export const { setSignUpStage, setSubscriptionStage, setPhoneValidationStage } =
  SignUpFormSlice.actions;

// Use useSelector directly to avoid circular dependency with store.ts
export const useSignUpFormSlice = () =>
  useSelector((state: { signUpForm: ISignUpFormState }) => state.signUpForm);

export { SignUpFormSlice };
